.dipLabel {
  display: block;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--mantine-color-dimmed);
  margin-bottom: 6px;
}

.dipRowLabel {
  font-size: 0.8rem;
  color: var(--mantine-color-dimmed);
  width: 52px;
  flex-shrink: 0;
}

/* Visual DIP switch */
.dipSwitches {
  display: flex;
  gap: 4px;
}

.dipSwitch {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.dipNub {
  width: 14px;
  height: 26px;
  border-radius: 2px;
  background: var(--mantine-color-dark-4);
  position: relative;
  border: 1px solid var(--mantine-color-dark-3);
}

.dipNub::after {
  content: "";
  position: absolute;
  left: 2px;
  right: 2px;
  height: 10px;
  border-radius: 1px;
  background: var(--mantine-color-dark-2);
  transition: top 0.1s;
}

.dipSwitchesMismatch .dipNub::after {
  background: var(--mantine-color-red-6);
}

.dipNubOn::after {
  top: 2px;
  background: var(--mantine-color-green-6);
}

.dipNubOff::after {
  top: 12px;
}

.dipNubUnknown::after {
  top: 7px;
  opacity: 0.4;
}

.dipSwitchesMismatch .dipNubOn::after {
  background: var(--mantine-color-orange-6);
}

.dipBitLabel {
  font-size: 0.65rem;
  color: var(--mantine-color-dimmed);
  line-height: 1;
}
